



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ConditionGroup from './condition-group.vue';

/**
 * 触发器 触发条件
 *
 * @author liyuyao
 * @date 08/20/2019
 */
@Component({
    components: {
        ConditionGroup
    }
})
export default class TriggerConditions extends Vue {
    @Prop({ default: 0 })
    submitSingle: number;
    @Prop()
    conditions: CommonTypes.conditionGroupDo[];
    @Prop()
    itemLogic: string;

    conditionsForm: any = {
        groupLogic: 'OR',
        conditionGroups: []
    };
    mounted() {
        if (!this.triggerId) {
            this.conditionsForm.conditionGroups = [{} as any];
        }
    }
    @Watch('conditions', { deep: true, immediate: true })
    onGetDetailConditions() {
        if (this.conditions && this.conditions.length) {
            this.conditionsForm.conditionGroups = this.conditions;
        }
    }
    @Watch('itemLogic', { immediate: true })
    onItemChange() {
        if (this.itemLogic) {
            this.conditionsForm.groupLogic = this.itemLogic;
        }
    }
    addGroup() {
        this.conditionsForm.conditionGroups.push({} as any);
    }

    deleteGroup(index) {
        this.conditionsForm.conditionGroups.splice(index, 1);
        this.$emit('change', this.conditionsForm);
    }

    conditionGroupChange(conditions, index) {
        this.conditionsForm.conditionGroups[index] = conditions;
        this.$emit('change', this.conditionsForm);
    }
    hasError(hasArror) {
        this.$emit('error', hasArror);
    }
    get triggerId() {
        return this.$route.query.id;
    }
}
